export { ReactComponent as ElementFile } from './svgs/element-file.svg';
